import React from 'react';
import Modal from '@common/modal';
import classnames from 'classnames/bind';
import styles from './modals.module.scss';
const cx = classnames.bind(styles);

interface ContractEndModalProps {
  visible: boolean;
  onClose: () => void;
  isUseScrollHidden?: boolean;
}

const ContractEndModal = ({ visible, onClose, isUseScrollHidden }: ContractEndModalProps) => {
  return (
    <Modal visible={visible} isUseScrollHidden={isUseScrollHidden}>
      <div className={cx('layer', 'layerError')}>
        <em className={cx('title')}>지원이 제한된 포지션입니다.</em>

        <p className={cx('desc')}>기업의 인사담당자님께 문의해 주세요.</p>

        <div className={cx('btnArea')}>
          <a className={cx('btn', 'confirm')} role="button" onClick={onClose}>
            확인
          </a>
        </div>
      </div>
    </Modal>
  );
};

export default ContractEndModal;
